<button class="detail-button" mat-button color="accent" (click)="onClick(0)">
    <span>{{data}}</span>
    <mat-icon>chevron_right</mat-icon>
</button>